<html>
<body>
  <div class="container-fluid divParent">
    <div class="col-sm-12 divChild">
      <mat-toolbar  class="login-toolbar justify-content-center">
      
      </mat-toolbar> 

      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-10 bg-color-card">

            <div class="col-md-12">     
              <h1 class="login-header">Reset Password</h1>
            <!-- <p class="login-sub-header">Enter below requsted details and reset the password</p> -->

            <form  [formGroup] ="loginForm" (ngSubmit)="onSubmit()">  
              <input type="hidden" formControlName="id">                 
                <div class="form-group">
                  <label for="username" class="col-form-label labelColor">Username</label>
                  <div class="input-group">
                  <input type="text" formControlName="username" class="form-control form-control-lg dark-input-field"  [class.is-invalid]="formErrors.username" (blur)="logValidationErrors()" placeholder="Username">                   
                </div>
                <span class="text-danger" *ngIf="formErrors.username"><small>{{formErrors.username}}</small> </span> 
              </div>  

                <div formGroupName ="passwordGroup">                
                <div class="form-group">
                    <label for="newPassword" class="col-form-label labelColor">New Password</label>
                    <div class="input-group">
                    <input type="password" formControlName="newPassword" class="form-control form-control-lg dark-input-field"  [class.is-invalid]="formErrors.newPassword" (blur)="logValidationErrors()" placeholder="New Password">                   
                  </div>
                  <span class="text-danger" *ngIf="formErrors.newPassword"><small>{{formErrors.newPassword}}</small> </span> 
                </div>   

                  <div class="form-group">
                    <label for="confirmPassword" class="col-form-label labelColor">Confirm Password</label>
                    <div class="input-group">
                    <input type="password" formControlName="confirmPassword" class="form-control form-control-lg dark-input-field"  [class.is-invalid]="formErrors.confirmPassword" (blur)="logValidationErrors()" placeholder="Confirm Password">                   
                  </div>
                  <span class="text-danger" *ngIf="formErrors.confirmPassword"><small>{{formErrors.confirmPassword}}</small></span> 
                  <span class="text-danger" *ngIf="formErrors.passwordGroup"><small>{{formErrors.passwordGroup}}</small></span>                                           
                </div>
                
            </div>

                  
                  <button [disabled]="!loginForm.valid" 
                   [ngClass]="{'loginBtnActive' : loginForm.valid,'loginBtnDisabled' : !loginForm.valid }"
                    type="submit" class="btn btn-lg btn-block">
                  <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                   RESET PASSWORD
                  </button>
        
                  <br>
                  <div class="row">
                    <div class="col-8">
                        <a  routerLink="/pages"  class="labelColor">Back to Home</a>
                    </div>
                  </div> 
           
            </form> 
          </div>

            </div>      
          </div>

     
    </div>
</div>
</body>
</html>





  

    
          <!-- user Login : {{ userLoginForm.value | json }} -->


